// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invSupplierStatusEnum } from './InvSupplierStatusEnum';
import { z } from 'zod';
export const invSupplierId = (z.number());
export const invSupplier = z.object({
    id: invSupplierId,
    name: z.string(),
    url: z.string().nullable(),
    created_at: z.date().nullable(),
    updated_at: z.date().nullable(),
    contact_info: z.string().nullable(),
    status: invSupplierStatusEnum,
});
export const invSupplierInitializer = z.object({
    id: invSupplierId.optional(),
    name: z.string(),
    url: z.string().optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
    contact_info: z.string().optional().nullable(),
    status: invSupplierStatusEnum.optional(),
});
export const invSupplierMutator = z.object({
    id: invSupplierId.optional(),
    name: z.string().optional(),
    url: z.string().optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
    contact_info: z.string().optional().nullable(),
    status: invSupplierStatusEnum.optional(),
});
//# sourceMappingURL=InvSupplier.js.map